import * as React from "react";
import AbstractLookup, { LookupConfigInterface } from "./AbstractLookup";
import { LookupInterface } from "./LookupInterface";
import * as onClickOutside from "react-onclickoutside";

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

import Translator from "../../../Translation/Translator";
import Constants from "../../../Action/Constants";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";

class ContractLookup extends AbstractLookup implements LookupInterface {

  protected componentRef: any;
  protected config: LookupConfigInterface = {
    entities: this.props.app.contracts,
    type: Constants.LOOKUP_COMPONENT_CONTRACT_CREATE_START,
    payloadPrefix: "contract",
    entityTranslation: Translator.trans("contract"),
    disableEntityCreation: this.props.disableEntityCreation || false,
    floatingLabelText: this.props.floatingLabelText || Translator.trans("contract"),
    labelText: this.props.floatingLabelText || Translator.trans("contract"),
    buttonLabel: this.props.buttonLabel || Translator.trans("label-new-contract"),
    dialogTitle: this.props.dialogTitle || Translator.trans("title-new-contract"),
    dialogType: this.props.dialogType || Constants.LOOKUP_COMPONENT_DIALOG_TYPE_SMALL,
    visibilityProperty: "displayName",
    dialogInputToComponentSyncProperty: "name",
    componentState: {
      name: ""
    },
    filter: this.props.filter || false,
    createPage: "",
    linkedObjectUrl: "/app/contract/update/",
    noResultText: this.props.noResultText || Translator.trans("dropdown-unit-notfound")
  };

  constructor(public props) {
    super(props);
  }

  public syncDialogValue(value: string): any {
    this.config.componentState.name = value;
    this.setState({
      name: value
    });
  }

  public getList(): any[] {
    let list: ContractInterface[] = this.getEntities()
    .filter((contract: ContractInterface) => {
      return contract.displayName.toLowerCase().includes(String(this.state.searchText).toLowerCase());
    })

    return list.map((contract: ContractInterface, index: number) => {
      return (
        <ListItem
          key={index}
          onMouseDown={this.onSelect.bind(this, contract)}
        >
          <ListItemAvatar>
            <Avatar className="avatar">
              {contract.renderAvatar()}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={contract.displayName}
          />
        </ListItem>
      );
    });
  }

  public getEntities(): ContractInterface[] {
    if (Array.isArray(this.props.entitiesToSearch)) {
      return this.props.entitiesToSearch;
    } else {
      const filteredContracts = this.props.app.contracts.filter(contract => !!contract)
        .filter((contract: ContractInterface) => {
          return contract.removed === false || (contract.removed === true && !!this.props.autoSelectId && contract.id === this.props.autoSelectId);
        })
        .filter((contract: ContractInterface) => {
          if (this.props.filterSignedAndExpiring) {
            return contract.isSigned || contract.isExpiring;
          }
          return contract;
        })
        .sort((contract1: ContractInterface, contract2: ContractInterface) => {
          if (contract1.firstDate < contract2.firstDate) {
            return 1;
          }
    
          if (contract1.firstDate > contract2.firstDate) {
            return -1;
          }
    
          return  0;
        });
      return filteredContracts;
    }
  }

  public getPayloadFromComponent(): any {
    return {};
  }
}

export default onClickOutside(ContractLookup);
